module.exports = __webpack_public_path__ + "img/02.5461f3ac.png";